export default "__VITE_ASSET__W4ld$YwB__"